module.exports = __webpack_public_path__ + "img/ba.357ffa01.jpg";